import { OrderPolicy } from './order/OrderPolicy';
import { WeeklyEarningsPolicy } from './sales/WeeklyEarningsPolicy';
import { SchedulePolicy } from './schedule/SchedulePolicy';
import { ProspectPolicy } from './prospect/ProspectPolicy';
import { BackorderPolicy } from './backorder/BackorderPolicy';
import { DailySubdirectorPolicy } from './daily/DailySubdirectorPolicy';
import { VisorPolicy } from './visor/VisorPolicy';

const Policies = {
  OrderPolicy,
  WeeklyEarningsPolicy,
  SchedulePolicy,
  ProspectPolicy,
  BackorderPolicy,
  DailySubdirectorPolicy,
  VisorPolicy,
};

export default Policies;
